import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Chip, FormControl, Input } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormField = styled(FormControl)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  flexWrap: 'wrap',
  flexDirection: 'row',
  border: '1px solid lightgray',
  borderRadius: '10px',
  backgroundColor: 'white',
  padding: 4,
  '&> div.container': {
    gap: '6px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  '& > div.container > span': {
    backgroundColor: 'gray',
    padding: '1px 3px',
    borderRadius: '4px',
  },
}));

const ChipTextField = ({ input: { onChange } }) => {
  const [values, setValues] = useState([]);
  const [currValue, setCurrValue] = useState('');

  const handleKeyUp = (e) => {
    const newValue = e.target.value;
    if (newValue.includes(',')) {
      setValues((oldState) => [...oldState, newValue.replace(/,/g, '')]);
      setCurrValue('');
    }
  };

  useEffect(() => onChange(values), [values]);

  const handleChange = (e) => {
    setCurrValue(e.target.value);
  };

  const handleDelete = (index) => {
    const arr = [...values];
    arr.splice(index, 1);
    setValues(arr);
  };

  return (
    <StyledFormField>
      <div className="container">
        {values.map((item, index) => (
          <Chip
            key={item}
            size="small"
            onDelete={() => handleDelete(index)}
            label={item}
          />
        ))}
      </div>
      <Input
        disableUnderline
        value={currValue}
        onChange={handleChange}
        onKeyDown={handleKeyUp}
      />
    </StyledFormField>
  );
};

ChipTextField.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
};

export default ChipTextField;
